import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'GooglePaySvg',
  props: {
    width: { default: 102 },
    height: { default: 64 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})